import * as React from 'react';
import * as firebase from 'firebase' ;
import { Link } from 'react-router-dom';
import { BaseComponent, BaseComponentProps, BaseComponentState } from '../base/BaseComponent';
import { SecurityData } from '../shared/index'; 
import { CurrencyList } from './CurrencyList';
import { LanguangeList } from './LanguangeList';
import { MyAccount } from './MyAccount';
import { WishList } from './WishList';
import { newI18n } from '../core/Const';
// import { }
export interface MenuAndLogoProps extends BaseComponentProps {
	lang: string;
	currency: string;
	user_login: boolean; 
	currencyChange: (cur: string) => any; 
	user: SecurityData.ApplicationUser; 
	languageChange: (lang: string) => any;
	hengleUserDialogClose: () => any;
	userDialogOpen: boolean;
	accountHandleClick: () => any;
	wishlistCount: number;
	changeCurrency: boolean;
	history: History | any;
	userAccess: string;
	firebaseApp: firebase.app.App ; 
}
export interface MenuAndLogoState extends BaseComponentState {
}

export default class MenuAndLogo extends BaseComponent<MenuAndLogoProps, MenuAndLogoState> {
	constructor(props: MenuAndLogoProps) {
		super(props);
	}

	render() {
		if ( this.state.haveReactError ) {
            return this.renderErrorPanel() ; 
        } 
		// let ulstyle = '';
		// this.props.user_login ? ulstyle = '' : ulstyle = 'signin';

		return (
			<div className="navbar navbar-default " role="navigation">
				{/*<Notification options={{ zIndex: 5000 }} />*/}
				<div className="container">
					<div className="navbar-header">
						<a className="pull-left menu-toggler hidden-md hidden-lg mobile-button" id="menu-toggler" data-toggle="collapse" href=".navbar-collapse"> <span className="sr-only">Toggle navigation</span>
							<i className="ti-align-justify" /> </a>
						<a className="pull-right hidden-md hidden-lg margin-right-20  mobile-button mobile-menu-search" onClick={this.props.accountHandleClick}>
							<span className="sr-only">Login</span>
							<i className="ti-user" /> </a>
						<Link to="/" className="navbar-brand"> <img src="/assets/images/logo.png" id='main_log_image' className="header-logo" alt="Bali Hotels and More" /> </Link>
					</div>
					<div className="navbar-collapse collapse">
						<ul className="nav navbar-nav navbar-left">
							<li>
								<Link to="/about-us">
									<span style={{textTransform: 'capitalize'}}> {newI18n("MENU.AboutUs", "About Us")} </span> 
								</Link>
							</li>
							<li>
								<Link to="/news">
									<span style={{textTransform: 'capitalize'}}> {newI18n("MENU.AboutBali", "About Bali")}  </span> 
								</Link>
							</li> 
							<li>
								<Link to="/contact-us">
									<span style={{textTransform: 'capitalize'}}> {newI18n("MENU.ContactUs", "Contact Us ")}</span> 
								</Link>
							</li>
							<li>
								<a href="http://baliholidaysandmorevip.com" target="_blank">
									<span style={{textTransform: 'capitalize'}}> {newI18n("MENU.BaliVIP", "Bali VIP")} </span> 
								</a>
							</li>
							<li>
								<a href="https://flight.balihotelsandmore.com/" target="_blank">
									<span style={{textTransform: 'capitalize'}}> {newI18n("MENU.BaliFlights", "Bali Flights")} </span> 
								</a>
							</li>
						</ul>

						<ul className="nav navbar-nav navbar-right">
							<LanguangeList lang={this.props.lang} languageChange={this.props.languageChange} />
							<CurrencyList
								lang={this.props.lang}
								currency={this.props.currency} 
								currencyChange={this.props.currencyChange}
								changeCurrency={this.props.changeCurrency}
							/>
							<WishList lang={this.props.lang} currency={this.props.currency} wishlistCount={this.props.wishlistCount} />
							<li className="signin" >
								<a
									className="dropdown-toggle"
									onClick={this.props.accountHandleClick}
									data-toggle="dropdown"
								>
									<i className="fa fa-sign-i" /> <span className='signin-btn'> {this.props.user_login ? 'My Account' :
										` Sign In`
									} </span> 
								</a>
								{
									<MyAccount
										firebaseApp={this.props.firebaseApp}
										isOpen={this.props.userDialogOpen}
										user={this.props.user}
										lang={this.props.lang}
										hengleUserDialogClose={this.props.hengleUserDialogClose}
										user_login={this.props.user_login} 
										history={this.props.history}
										userAccess={this.props.userAccess}
									/>
								}
							</li>

						</ul>

					</div>
				</div>

			</div>
		);
	}
} 


// WEBPACK FOOTER //
// ./src/header/MenuAndLogo.tsx